export default __webpack_public_path__ + "static/media/leadModuleInActiveIcon.5cb1651d.svg";